<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Edit Encoding Profile</modal-header>
        </div>
        <div>
          <form-group>
            <field disabled name="Name" :value="name" v-model="name" />
          </form-group>
        </div>
        <div>
          <form-group>
            <field name="Slug" :value="slug" v-model="slug" />
          </form-group>
        </div>
        <div>
          <form-group>
            <label>Data</label>
            <textarea rows="10" class="form-control" v-model="data" placeholder='{
      "module": "@otomo/action-encode",
      "preset": "mp4",
      "output": "encoded.mp4",
      "params": {
            "-acodec": "aac",
            "-ab": "128k",
            "-ar": "44100",
            "-vcodec": "libx264",
            "-r": "25"
        }
}'
            >
            </textarea>
          </form-group>
        </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import {modalMixin} from '@/mixins/modalMixin'
import {encodingProfileMixin} from '@/mixins/encodingProfileMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_edit_encoding_profile',
  mixins: [modalMixin, encodingProfileMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field
  },
  props: {
    show: Boolean,
    confirmId: String,
    slugField: String,
    field: String,
    fieldType: String
  },
  data: () => ({
    name: '',
    slug: this.slugField,
    data: ''
  }),
  mounted () {
    this.name = this.field
    this.slug = this.slugField
    this.data = JSON.stringify(JSON.parse(this.fieldType), null, 2)
  },
  methods: {
    confirm () {
      this.startLoading()
      const data = {
        id: this.confirmId,
        display_name: this.name,
        slug: this.slug,
        data: JSON.parse(this.data)
      }
      this.updateEncodingProfile(data).then(() => {
        this.addNotification('success', 'Encoding Profile updated successfully.')
        this.getEncodingProfiles().then(() => {
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  },
  watch: {
    field: function () {
      this.name = this.field
    },
    slugField: function () {
      this.slug = this.slugField
    },
    fieldType: function () {
      this.data = JSON.stringify(JSON.parse(this.fieldType), null, 2)
    }
  }
}
</script>

<style lang="scss">
.password-error{
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/encoding-profile/modal-edit-encoding-profile.vue